import { useContext } from "react";
import { AdminAuthContext, type AdminAuthContextType } from "./AdminAuthContext";

export type { AdminAuthContextType };

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error("useAdminAuth must be used within AdminAuthProvider");
  }
  return context;
}
